<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="ded"><em>To Luis Alvarez, George Comstock, Richard Gray,<br/>and all who worked on AN/MPN-1 XE—<br/>wherever they may be</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?7c814526